import SiteLayout from "@/components/feature/SiteLayout";
import PageBanner from "@/components/feature/PageBanner";
import AboutSubNav from "@/components/feature/AboutSubNav";
import { companyHistory } from "@/mocks/about";

export default function AboutHistoryPage() {
  const sortedHistory = [...companyHistory].sort((a, b) => b.year - a.year);

  return (
    <SiteLayout navVariant="solid">
      <PageBanner
        title="회사연혁"
        subtitle="1975년 창립부터 현재까지, 반세기 성장의 발자취"
        breadcrumb={[
          { label: "회사소개", to: "/about/overview" },
          { label: "회사연혁" },
        ]}
        bgImage="https://readdy.ai/api/search-image?query=Modern%20clean%20industrial%20manufacturing%20facility%20interior%20with%20organized%20production%20floor%20and%20natural%20light%20streaming%20through%20windows%2C%20professional%20engineering%20environment%2C%20warm%20industrial%20aesthetic%2C%20soft%20ambient%20lighting%2C%20crisp%20architectural%20photography&width=1600&height=680&seq=krubber-about-banner&orientation=landscape"
      />
      <AboutSubNav />

      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
          <div className="relative">
            <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px" />

            {sortedHistory.map((item, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={`${item.year}-${item.month}`}
                  className={`relative flex flex-col md:flex-row items-start gap-6 md:gap-10 pb-12 md:pb-16 ${
                    isLeft ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  <div className={`flex-1 ${isLeft ? "md:text-right md:pr-20" : "md:text-left md:pl-20"}`}>
                    <div className="hidden md:block">
                      <span className="inline-block px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-extrabold">
                        {item.year}
                      </span>
                    </div>
                  </div>

                  <div className="absolute left-[22px] md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-4 border-background-50 -translate-x-1/2 z-10 mt-1" />

                  <div className="flex-1 pl-14 md:pl-0">
                    <div className={`${isLeft ? "md:pl-20" : "md:pr-20"}`}>
                      <div className="md:hidden mb-2">
                        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-extrabold">
                          {item.year}
                        </span>
                      </div>
                      <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                        <p className="text-xs font-bold text-primary-600 mb-1">
                          {item.year}년{item.month > 0 ? ` ${item.month}월` : ""}
                        </p>
                        <p className="text-sm text-foreground-800 leading-relaxed">{item.content}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}